import React, { StrictMode } from 'react'
import { render } from 'react-dom'
import Carousel from './components/carousel/Carousel'


export const renderCarousel = (
  el = document.querySelector('.carousel-widget'),
  carousel = {},
) => {
  if (el) {
    if (typeof Array.isArray(carousel.slides)) {
      render(
        <StrictMode><Carousel data={carousel} /></StrictMode>,
        el
      )
    }
  }
}
